export default __webpack_public_path__ + "static/iphone-x-body-ad8799ffd48fd14a21e0719151b74a1f.png";